import { Badge } from "@components/ui/badge";

type TemplateTypeBadgeProps = {
  isCustom: boolean;
};

export const TemplateTypeBadge = ({ isCustom }: TemplateTypeBadgeProps) => {
  const templateType = isCustom ? "Custom" : "System Default";
  const badgeVariant = isCustom ? "warning" : "accent";

  return <Badge variant={badgeVariant}>{templateType}</Badge>;
};
